import { Flex, P, Radio } from '@dnb/eufemia';
import { useId } from 'react';

import { useUrlFilters } from '@/hooks/useUrlFilters';
import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

export const CLASSIFICATION_FILTER_KEY = 'type';

interface Props {
  classifications: string[];
  classificationCount: Record<string, number>;
  allApiCount?: number;
}

export default function TypeFilter({ classifications, classificationCount, allApiCount }: Props) {
  const { updateFilterInURL, getSelectedKeysFromURL } = useUrlFilters();
  const groupName = `api-type-${useId()}`;

  const classificationOptions = classifications.map((type) => ({
    selectedKey: type,
    content: [type],
  }));

  const selectedFilters = getSelectedKeysFromURL(CLASSIFICATION_FILTER_KEY, classificationOptions);
  const selectedValue = selectedFilters[0] || '';

  const handleChange = (value: string) => {
    updateFilterInURL(CLASSIFICATION_FILTER_KEY, [value], classificationOptions);
  };

  return (
    <Flex.Vertical top="small">
      <P space={{ bottom: 'x-small' }} weight="medium">
        Type
      </P>
      <Radio.Group
        layoutDirection="column"
        name={groupName}
        onChange={({ value }) => value && handleChange(value)}
        value={selectedValue}
      >
        {classifications.map((type) => (
          <Radio
            key={type}
            label={`${capitalizeFirstLetterOfString(type.toLowerCase())} (${
              type === 'all' ? (allApiCount ?? 0) : (classificationCount[type] ?? 0)
            })`}
            size="medium"
            value={type}
          />
        ))}
      </Radio.Group>
    </Flex.Vertical>
  );
}
